import { PureComponent, ReactNode } from "react";

export default class LoadingScreenComponent extends PureComponent {
  render(): ReactNode {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="loader">
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--dot"></div>
          <div className="loader--text"></div>
        </div>
      </div>
    );
  }
}
